import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";

export const renderDateAndTime = (startDate: string, startTime: string) =>
<>
    <EventCardSectionItem content={startDate} className="rj-ev-list__ev-card__date" />
    <EventCardSectionItem content={startTime} className="rj-ev-list__ev-card__time" />
</>